import React, { useEffect, useState } from 'react'
import styled, { keyframes } from 'styled-components'

import LoadingSpinner from './LoadingSpinner'
import ResultHandler from './ResultHandler'
import { DataByResultCode, base64ToFile, onSetValueOCR } from './until'
import { useDispatch, useSelector } from 'react-redux'
import { state_action } from '../ActionHelper'
import GetUserAgent from '../action/GetUserAgent'
import { callAPIOCR } from '../action/ocr'
import { IMAGE_FORMATS } from 'e-submission/utils/pattern'

const slideInFromTop = keyframes`
  from {
    opacity: 0;
    transform: translateY(-20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
`

// สร้าง styled component สำหรับ ResultHandler ที่มี animation
const AnimatedResultHandler = styled.div`
  animation: ${slideInFromTop} 0.3s forwards;
`

const AsyncLoading = ({ onNextPage, typemodal, DataImage, onSaveImageOCR, CountCallAPIFail, onAPIFail, onExit }) => {
  const dispatch = useDispatch()
  const stateApp = useSelector((state) => state.apps)
  const stateData = useSelector((state) => state.data)
  const [isLoaded, setIsLoaded] = useState(false)
  const [objResult, setObjResult] = useState({
    title: 'ผลการแสกนหน้าบัญชีธนาคาร',
    userinfo: {
      bankname: 'KBank',
      name: 'Mr. Bank Kub',
      banknumber: '1234567890',
    },
    message: 'ระบบไม่สามารถสแกนหน้าบัญชีธนาคารได้  กรุณากรอกข้อมูลบัญชีธนาคารด้วยตนเอง',
    onSubmit: () => {
      onNextPage(state_action.doneflow, null)
    },
    // onCancel: null,
    onCancel: () => {
      onNextPage(state_action.doneflow, null)
    },
    onClose: () => {
      onNextPage(state_action.doneflow, null)
    },
  })

  const userData = GetUserAgent()

  useEffect(() => {
    onCallCheck()
  }, [])

  const onCallCheck = async () => {
    try {
      const currentPayer = stateApp.byId[stateApp.currentAppId]
      const currentAppData = stateData.bank
      let resultResult = await callAPIOCR(
        userData,
        {
          image: DataImage ? 'data:image/jpeg;base64,' + DataImage : 'test',
          policyId: currentPayer.policyId,
        },
        currentPayer
      )

      const file = base64ToFile(
        'data:image/jpeg;base64,' + DataImage,
        'ocr_' + new Date().getTime() + '.jpeg',
        IMAGE_FORMATS.JPEG
      )

      let ApiCode = resultResult.statusCode
      if (ApiCode >= 400 && CountCallAPIFail < 3) {
        onAPIFail()
      } else {
        onSaveImageOCR(file)
      }

      let resultObj = DataByResultCode(ApiCode)

      setObjResult({
        title: resultObj.title,
        userinfo: resultObj.sub_message,
        message: resultObj.message,
        onSubmit: () => {
          if ([200].includes(ApiCode)) {
            onNextPage(state_action.doneflow, null)
          } else if ([201].includes(ApiCode)) {
            onSetValueOCR(dispatch, resultResult.apptype, currentAppData, resultResult)
            onNextPage(state_action.doneflow, null)
            onExit()
          } else if (400 >= ApiCode && CountCallAPIFail >= 3) {
            onNextPage(state_action.doneflow, null)
            onExit()
          } else {
            onNextPage(state_action.consentinfo, null)
          }
        },
        // onCancel: null,
        onCancel: resultObj.Cancel
          ? () => {
              onNextPage(state_action.consentinfo, null)
            }
          : null,
        onClose: () => {
          onNextPage(state_action.doneflow, null)
        },
      })
      if (ApiCode == 200) {
        onSetValueOCR(dispatch, resultResult.apptype, currentAppData, resultResult)
        onExit()
      }
      setIsLoaded(true)
    } catch (error) {
      console.error('asuncLadding error:', error)
    }
  }

  return (
    <div>
      {!isLoaded && <LoadingSpinner />}
      {isLoaded && (
        <AnimatedResultHandler>
          <ResultHandler props={objResult} />
        </AnimatedResultHandler>
      )}
    </div>
  )
}

export default AsyncLoading
